import type { ReactNode } from 'react';
import styles from './auth-layout.module.css';

type FormHeaderBandProps = {
  children: ReactNode;
};

/** Login card header — title row only, same plane as card body. */
export function FormHeaderBand({ children }: FormHeaderBandProps) {
  return <div className={styles.formHeaderBand}>{children}</div>;
}
